// The keys that hold a person's wallet: which documents were checked and by which Persona inquiry,
// the credentials issued for them, what they picked to share or pay for, and their consents. These
// belong to the person alone, so they are kept in private data, never in the public data anyone
// can read. Older listings and profiles may still carry them in public data, which is why reads
// fall back to it and writes move them across.
//
// Written as plain CommonJS with no imports so the API server, which runs its files under plain
// node, can require this same file the browser bundle imports.

const WALLET_RECORD_KEYS = Object.freeze([
  'documentVerificationChecks',
  'personaDocumentDetails',
  'verificationIdentityChecks',
  'documentCompletionHistory',
  'dockIoCredentials',
  'selectedWalletDocs',
  'selectedItemsCheckout',
  'educationVerification',
  'experienceVerification',
  'consentForVerification',
  'consentForWallet',
  'workChecks',
]);

const isPresent = value => value !== undefined && value !== null;

const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value);

// Reads one wallet record from a listing's attributes or a user's profile. The private copy wins;
// the public copy is only used for a record that has not been moved yet.
const walletRecordOf = (holder, key) => {
  const privateValue = holder?.privateData?.[key];
  if (isPresent(privateValue)) return privateValue;
  return holder?.publicData?.[key];
};

// Prepares an update so no wallet record is written to public data. Each record found in public
// data is copied into private data, unless private data already holds a value for it (that one is
// newer), and is set to null in public data, which removes it there. `moved` names the keys that
// were taken out. When there is nothing to move the inputs are handed back as they are, so a
// caller can tell no change is needed. The inputs are never changed.
const separateWalletRecords = ({ publicData, privateData } = {}) => {
  if (!isObject(publicData)) return { publicData, privateData, moved: [] };

  const moved = WALLET_RECORD_KEYS.filter(key => isPresent(publicData[key]));
  if (moved.length === 0) return { publicData, privateData, moved };

  const nextPublic = Object.assign({}, publicData);
  const nextPrivate = Object.assign({}, isObject(privateData) ? privateData : {});
  moved.forEach(key => {
    if (!isPresent(nextPrivate[key])) nextPrivate[key] = publicData[key];
    nextPublic[key] = null;
  });
  return { publicData: nextPublic, privateData: nextPrivate, moved };
};

module.exports = { WALLET_RECORD_KEYS, walletRecordOf, separateWalletRecords };
